import { HabitSchedule } from '@griply/types';
import { addDays, subDays } from 'date-fns';

export type ScheduleBounds = {
  minDate: Date | undefined;
  maxDate: Date | undefined;
};

export const getAdjacentScheduleBounds = (
  schedules: HabitSchedule[],
  targetSchedule: HabitSchedule,
): ScheduleBounds => {
  const sorted = schedules
    .slice()
    .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());

  const targetStart = targetSchedule.startDate.getTime();
  const currentIndex = sorted.findIndex(
    (schedule) => schedule.startDate.getTime() === targetStart,
  );

  if (currentIndex === -1) {
    return { minDate: undefined, maxDate: undefined };
  }

  const previousSchedule = sorted[currentIndex - 1];
  const nextSchedule = sorted[currentIndex + 1];

  const minDate = previousSchedule?.endDate
    ? addDays(previousSchedule.endDate, 1)
    : undefined;

  const maxDate = nextSchedule ? subDays(nextSchedule.startDate, 1) : undefined;

  return { minDate, maxDate };
};
